import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Dataset must contain 'user_nse' column
 */
export class ColumnaUserNseFaltanteParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Dataset must contain");
    }

    public traducir(): string {
        return "Falta la columna \'user_nse\' en el archivo";
    }
}
